import { Fragment, useMemo, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import { getCategoryColumns } from "../../Components/product/Category.columns";
import { CategoryModal } from "../../Components/order/CategoryModal";
import { useAdmin } from "../../../context/AdminContext";

export const CategoryList = () => {
  const { getData, patchData, postData, invalidateQuery } = useDataFetch();
  const { admin } = useAdmin();
  const { data, isLoading } = getData(["categories"], "/product/all/categories", { enabled: true });

  const { mutateAsync: toggleCategory } = patchData("/product/category/toggle-status", {}, {
    onSuccess: (response) => {
      if (response.message === "toggle_category_status_success") {
        toast.success("Estado de la categoría actualizado");
        invalidateQuery(["categories"]);
      }
    },
  });

  const { mutateAsync: createCategory } = postData("/product/category", {}, {
    onSuccess: (response) => {
      if (response.message === "create_category_success") {
        toast.success("Categoría creada exitosamente");
        invalidateQuery(["categories"]);
        closeModal();
      }
    },
  });

  const { mutateAsync: updateCategory } = patchData("/product/category", {}, {
    onSuccess: (response) => {
      if (response.message === "category_updated_successfully") {
        toast.success("Categoría actualizada exitosamente");
        invalidateQuery(["categories"]);
        closeModal();
      }
    },
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
  });

  const openModalForCreate = () => {
    setFormData({ id: "", name: "" });
    setModalOpen(true);
  };

  const openModalForEdit = (category) => {
    setFormData({ id: category.id, name: category.name });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setFormData({ id: "", name: "" });
  };




  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => getCategoryColumns(columnHelper, openModalForEdit, toggleCategory,admin?.role),
    [columnHelper]
  );


  const categoryData = data?.data?.categories ?? [];

  return (
    <Fragment>
      <Breadcrumbs parent="Productos" title="Categorías" mainTitle="Listado de Categorías" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <div className="d-flex justify-content-end px-3 pt-3">
                <Btn
                  attrBtn={{
                    color: "success",
                    size: "sm",
                    id: "create-category-btn",
                    onClick: openModalForCreate,
                    disabled: admin?.role === "ASSISTANT",
                  }}
                >
                  <i className="fa fa-plus"></i> Registrar categoria
                </Btn>
                <UncontrolledTooltip placement="top" target="create-category-btn">
                  Registrar Categoría
                </UncontrolledTooltip>
              </div>
              <CardBody>
                <DataTable
                  data={categoryData}
                  columns={columns}
                  pagination
                  highlightOnHover
                  striped
                  responsive
                  progressPending={isLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Modal para Registrar y Editar */}
      <CategoryModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        formData={formData}
        setFormData={setFormData}
        createCategory={createCategory}
        updateCategory={updateCategory}
      />
    </Fragment>
  );
};
